import { render, staticRenderFns } from "./InternationalWire.vue?vue&type=template&id=27ee23fc&"
import script from "./InternationalWire.vue?vue&type=script&lang=js&"
export * from "./InternationalWire.vue?vue&type=script&lang=js&"
import style0 from "./InternationalWire.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports